import { isComingFromFBPaidAds } from "@faire/retailer-visitor-shared/lib/navigation-origin/isComingFromFBPaidAds";
import { isComingFromSEM } from "@faire/retailer-visitor-shared/lib/navigation-origin/isComingFromSEM";
import { isComingFromSEO } from "@faire/retailer-visitor-shared/lib/navigation-origin/isComingFromSEO";
import { isComingFromSocial } from "@faire/retailer-visitor-shared/lib/navigation-origin/isComingFromSocial";
import { LocationForOrigin } from "@faire/retailer-visitor-shared/lib/navigation-origin/LocationForOrigin";
import {
  FaireDirectSignUpTypes,
  SignUpType,
} from "@faire/retailer-visitor-shared/lib/popSignUp";
import { parseQueryParams } from "@faire/web/common/query-params/parseQueryParams";

// We should delete this file once all experiments related to the sign up revamp are done

const isPaidAds = (location: LocationForOrigin): boolean =>
  isComingFromFBPaidAds() || isComingFromSocial(location);

export const isFaireDirect = (location: LocationForOrigin): boolean =>
  parseQueryParams(location?.search ?? "").get("signUp") ===
  SignUpType.FAIRE_DIRECT;

export const isFaireDirectRequireEmailAddressSignUpFlow = (
  location: LocationForOrigin
): boolean =>
  parseQueryParams(location?.search ?? "").get("signUp") ===
  SignUpType.FAIRE_DIRECT_REQUIRE_EMAIL;

const isSEOorSEM = (location: LocationForOrigin): boolean =>
  isComingFromSEO(location) || isComingFromSEM(location);

export const isWidget = (location: LocationForOrigin): boolean => {
  const signup = parseQueryParams(location?.search ?? "").get("signUp");
  return signup === SignUpType.WIDGET_V2 || signup === SignUpType.WIDGET;
};

export const isRetailerSubUser = (location: LocationForOrigin): boolean =>
  parseQueryParams(location?.search ?? "").get("signUp") ===
  SignUpType.RETAILER_SUBUSER;

export const isFaireDirectCreditEligible = (
  location: LocationForOrigin
): boolean => {
  const signUpQueryParam = parseQueryParams(location?.search ?? "").get(
    "signUp"
  );

  return signUpQueryParam
    ? FaireDirectSignUpTypes.includes(signUpQueryParam as SignUpType)
    : false;
};

export const getSignupType = (location: LocationForOrigin) => {
  if (isWidget(location)) {
    return SignUpType.WIDGET;
  } else if (isFaireDirectRequireEmailAddressSignUpFlow(location)) {
    return SignUpType.FAIRE_DIRECT_REQUIRE_EMAIL;
  } else if (isRetailerSubUser(location)) {
    return SignUpType.RETAILER_SUBUSER;
  } else if (isFaireDirect(location)) {
    return SignUpType.FAIRE_DIRECT;
  } else if (isPaidAds(location)) {
    return SignUpType.PAID_ADS;
  } else if (isSEOorSEM(location)) {
    return SignUpType.SEM;
  } else {
    return SignUpType.GENERIC;
  }
};

export const readableSignUpType = {
  [SignUpType.WIDGET]: "Widget",
  [SignUpType.WIDGET_V2]: "Widget",
  [SignUpType.SHOPIFY_WIDGET]: "Shopify Widget",
  [SignUpType.FAIRE_DIRECT_REQUIRE_EMAIL]: "Faire Direct Require Email",
  [SignUpType.RETAILER_SUBUSER]: "Sub User",
  [SignUpType.FAIRE_DIRECT]: "Faire Direct",
  [SignUpType.PAID_ADS]: "Paid Ads",
  [SignUpType.SEM]: "SEM",
  [SignUpType.GENERIC]: "Generic",
  [SignUpType.AUTO]: "Auto",
  [SignUpType.TRADESHOW]: "Tradeshow",
  [SignUpType.RETAILER_LEAD_ADS]: "Retailer Lead Ads",
  [SignUpType.FOI_BANNER]: "First Order Incentive Banner",
  [SignUpType.FACEBOOK]: "Facebook",
  [SignUpType.PRODUCT]: "Product",
  [SignUpType.BRAND]: "Brand",
  [SignUpType.NAV_ACCOUNT]: "Nav Account",
  [SignUpType.NAV_CART]: "Nav Cart",
  [SignUpType.SEO_DISCOVER]: "SEO Discover",
};
